import { View } from "@/components/ui";
import { cn } from "@/lib/utils";
import { Link } from "@/components/shared/link";
import { Typography } from "../typography";

interface Props {
  items: {
    label: string;
    href: string;
  }[];
  active?: string;
}

export function NavTabs({ items, active }: Props) {
  return (
    <View
      className={cn(
        "flex",
        "flex-row",
        "justify-evenly",
        "border-b",
        "border-solid",
        "border-slate-200",
        "md:justify-start",
      )}
    >
      {items.map((item) => (
        <Link href={item.href} key={item.href}>
          <Nav label={item.label} focused={active === item.href} />
        </Link>
      ))}
    </View>
  );
}

function Nav({ label, focused }: { label: string; focused: boolean }) {
  return (
    <View
      className={cn(
        "mx-4",
        "flex",
        "h-11",
        "items-center",
        "justify-center",
        "relative",
      )}
    >
      <Typography
        variant="body-sm"
        style={{
          width: "110%", // workaround to allow text to prevent entering a new line without wrapping
        }}
        className={cn(
          "text-center",
          "text-base",
          focused ? "text-primary" : "text-secondary-text",
        )}
      >
        {label}
      </Typography>
      <View
        className={cn("absolute", "bottom-0", "left-0", "right-0", "mx-[20%]")}
      >
        <View
          className={cn(
            "h-[3px]",
            "w-full",
            "rounded-t-md",
            focused ? "bg-primary" : "bg-transparent",
          )}
        />
      </View>
    </View>
  );
}
